/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentV2 } from './DocumentV2';
import {
    DocumentV2FromJSON,
    DocumentV2FromJSONTyped,
    DocumentV2ToJSON,
    DocumentV2ToJSONTyped,
} from './DocumentV2';

/**
 * 
 * @export
 * @interface MultipleDistributionItem
 */
export interface MultipleDistributionItem {
    /**
     * 
     * @type {string}
     * @memberof MultipleDistributionItem
     */
    serviceName?: string;
    /**
     * 
     * @type {string}
     * @memberof MultipleDistributionItem
     */
    serviceAgreementId?: string;
    /**
     * 
     * @type {string}
     * @memberof MultipleDistributionItem
     */
    serviceRoleId?: string;
    /**
     * 
     * @type {string}
     * @memberof MultipleDistributionItem
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof MultipleDistributionItem
     */
    taskId?: string;
    /**
     * 
     * @type {Array<DocumentV2>}
     * @memberof MultipleDistributionItem
     */
    documents?: Array<DocumentV2>;
}

/**
 * Check if a given object implements the MultipleDistributionItem interface.
 */
export function instanceOfMultipleDistributionItem(value: object): value is MultipleDistributionItem {
    return true;
}

export function MultipleDistributionItemFromJSON(json: any): MultipleDistributionItem {
    return MultipleDistributionItemFromJSONTyped(json, false);
}

export function MultipleDistributionItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MultipleDistributionItem {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceName': json['serviceName'] == null ? undefined : json['serviceName'],
        'serviceAgreementId': json['serviceAgreementId'] == null ? undefined : json['serviceAgreementId'],
        'serviceRoleId': json['serviceRoleId'] == null ? undefined : json['serviceRoleId'],
        'status': json['status'] == null ? undefined : json['status'],
        'taskId': json['taskId'] == null ? undefined : json['taskId'],
        'documents': json['documents'] == null ? undefined : ((json['documents'] as Array<any>).map(DocumentV2FromJSON)),
    };
}

export function MultipleDistributionItemToJSON(json: any): MultipleDistributionItem {
    return MultipleDistributionItemToJSONTyped(json, false);
}

export function MultipleDistributionItemToJSONTyped(value?: MultipleDistributionItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serviceName': value['serviceName'],
        'serviceAgreementId': value['serviceAgreementId'],
        'serviceRoleId': value['serviceRoleId'],
        'status': value['status'],
        'taskId': value['taskId'],
        'documents': value['documents'] == null ? undefined : ((value['documents'] as Array<any>).map(DocumentV2ToJSON)),
    };
}

